/* ================================================================ */
// COMPONENT RESOLVER | ComponentResolver.js
/* ================================================================ */
/* ========================================== */
// Imports
/* ========================================== */
import React from 'react';
import PropTypes from 'prop-types';
// Constants
import { AlignmentTypes } from '@myglobe/core/dist/types';
// Local Components
import CesiumContainer from '../../components/Cesium/CesiumContainer';
import MapContainer from '../../components/Map/MapContainer';
import ActionButton from '../../components/ActionButton';
import Header from '../../components/Header';
import Sidebar from '../../containers/Sidebar';
import {default as StaticMenu, DynamicMenu} from '../../containers/Menu';
import Page from '../../containers/Page';
import Popup from '../../containers/Popup';
import StyledContainer from '../../containers/StyledContainer';
/* ========================================== */
// Helpers
/* ========================================== */
const ActionButtonConstructor = (props) => <ActionButton {...props} />;
const HeaderConstructor = (props) => <Header {...props} />;
const SidebarConstructor = (props) => <Sidebar {...props} />;
const PageConstructor = (props) => <Page {...props} />;
const PopupConstructor = (props) => <Popup {...props} />;
const MapConstructor = (props) => <MapContainer {...props} />;
const CesiumConstructor = (props) => <CesiumContainer {...props} />;
const StyledContainerConstructor = (props) => <StyledContainer {...props} />;
// TODO: Resolve menu via dynamic or static according to item type
const MenuConstructor = (props) => {
    console.log('MenuConst', props);
    if(Array.isArray(props.items))
        return <StaticMenu {...props} />;
    else
        return <DynamicMenu {...props} />;
};
const Components = {
    'Sidebar': SidebarConstructor,
    'Page': PageConstructor,
    'Popup': PopupConstructor,
    'Map': MapConstructor,
    'Cesium': CesiumConstructor,
    'Menu': MenuConstructor,
    'Header': HeaderConstructor,
    'StyledContainer': StyledContainerConstructor,
    'ActionButton': ActionButtonConstructor
};
/* ========================================== */
/**
 * Generate Key
 * ------------
 * Creates a key from the given name
 * and milliseconds since epoch
 * @param {*} name
 */
function generateKey(name) {
    return `${ name }_${ new Date().getTime() }`;
}
/* ========================================== */
/**
 * Resolve Components
 * ------------------
 * Resolves a component corresponding to the
 * schema's components configuration and returns this
 * as an array
 *
 * @param {array} components array of component configs
 */
function resolveComponents(components = []) {
    return components.map(componentConfig=>{
        // Get component from map
        const {name, children, ...props} = componentConfig;
        // Resolve component
        const resolveComponent = (componentKey, childrenConfig = [], props) => {
            try {
                console.log(componentKey);
                console.log(Components[componentKey]);
                const children = childrenConfig.map(childConfig=>{
                    const {name, children, ...props} = childConfig;
                    return resolveComponent(name, children, props);
                });
                const componentProps = {...props, key: generateKey(componentKey), children};
                console.debug('Layout > ComponentResolver | ', 'resolveComponents - ', 'componentProps:', componentProps);
                const component = Components[componentKey](componentProps);
                console.log(component);
                return component;
            } catch (e) {
                console.warn(`Invalid Component in schema ${componentConfig}: ${e}`);
                return null;
            }
        };
        return resolveComponent(name, children, props);
    });
}
resolveComponents.propTypes = {
    components: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.oneOf(Object.keys(Components)),
        style: PropTypes.object,
        align: PropTypes.oneOf(Object.values(AlignmentTypes)),
        children: PropTypes.arrayOf(PropTypes.shape({
            name: PropTypes.oneOf(Object.keys(Components)),
            style: PropTypes.object,
            align: PropTypes.oneOf(Object.values(AlignmentTypes))
        }))
    }))
};
export default resolveComponents;